<article class="absolute z-40 -mt-3 -ml-3">
    <div class="flex justify-center items-end">
        <div class="flex h-6 w-6 rounded-[50%] justify-center items-center" [ngStyle]="backgroundColor">
            <div class="h-3 w-3 rounded-[50%] bg-white"></div>
        </div>
    </div>
</article>